import { render, staticRenderFns } from "./ImagesListItem.vue?vue&type=template&id=2b1b7036&scoped=true&"
import script from "./ImagesListItem.vue?vue&type=script&lang=js&"
export * from "./ImagesListItem.vue?vue&type=script&lang=js&"
import style0 from "./ImagesListItem.vue?vue&type=style&index=0&id=2b1b7036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1b7036",
  null
  
)

export default component.exports